

import React, { useState, useEffect } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox,
  Typography, IconButton, Button, InputBase, CircularProgress,Pagination,Tabs,Tab
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { pdf } from '@react-pdf/renderer';
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import ActiveDetailsPDF from './ActiveDetailsPDF';
import active from "../../../../assets/Dashboard/active.svg";
import invited from "../../../../assets/Dashboard/invited.svg";
import inactive from "../../../../assets/Dashboard/inactive.svg";
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../../../components/BaseUrl';
import { decryptToken } from "../../../../Utlis/Encryption";
import {toast,Toaster} from "react-hot-toast"
import empty from "../../../../assets/empty.png";
import ExpensesTable from './ExpenseTable';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import AttendanceTable from './AttendanceTable';
import TasksTable from './TaskTable';
import DocumentsTable from './DocumentTable';
import PaymentsTable from './PaymentTable';
import RecentActivityTable from './RecentActivityTable';
const ActiveDetailsTable = ({ companyId ,companyAdminId}) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'first_name', direction: 'desc' });
  const [sortLoading, setSortLoading] = useState(false);
  const rowsPerPage = 6;
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const HaederStyles = {
    color: "#44546F",
    fontSize: "12px",
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    // textAlign:"center"
  };
  const DataStyles = {
    color: "#172B4D",
    fontSize: "12px",
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
          whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };

  const fetchTableData = async () => {
    try {
      if (sortLoading) setSortLoading(true);
      setLoading(false);
      const searchParam = searchTerm || '';
      const sortKey = sortConfig.key;
      const sortOrder = sortConfig.direction;
      const limit = rowsPerPage;
      const offset = page + 1;
    //  ${companyId}
      console.log("companyId",companyId)
  const res=  await fetch(`${BASE_URL}/public/workers?search=${encodeURIComponent(searchParam)}&sort_by=${sortKey}&
      sort_order=${sortOrder}&page=${offset}&limit=${limit}&company_id=${companyId}
     
      `, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await res.json();
      console.log("workkers",json)
      setTableData(json?.data?.records || []);
      setTotalPages(Math.ceil((json?.data?.pagination?.total || 0) / rowsPerPage));
    } catch (error) {
      console.error('Error fetching table data:', error);
    } finally {
      setLoading(false);
      setSortLoading(false);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [searchTerm, sortConfig, page]);

  const handleSelect = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortLoading(true);
    setSortConfig({ key, direction });
  };

  const handleExportPDF = async () => {
    const blob = await pdf(<ActiveDetailsPDF data={tableData} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Workers_Report.pdf';
    link.click();
    URL.revokeObjectURL(url);
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };
  
  const columns = [
    { key: 'id', label: t('activeDetailsTable.columns.id'), sortable: true },
    { key: 'first_name', label: t('activeDetailsTable.columns.admin'), sortable: true },
    { key: 'email', label: t('activeDetailsTable.columns.email'), sortable: true },
    { key: 'phone', label: t('activeDetailsTable.columns.phone'), sortable: true },
    { key: 'designation', label: t('activeDetailsTable.columns.department'), sortable: true },
    { key: 'employee_type', label: t('activeDetailsTable.columns.type'), sortable: true },
    { key: 'shift_schedule', label: t('activeDetailsTable.columns.shift'), sortable: true },
    { key: 'status', label: t('activeDetailsTable.columns.status'), sortable: true },
    { key: 'created_at', label: t('activeDetailsTable.columns.date'), sortable: true },
    { key: 'action', label: t('activeDetailsTable.columns.action'), sortable: false }
  ];

  const allSelected = tableData.length > 0 && selected.length === tableData.length;
  const isIndeterminate = selected.length > 0 && !allSelected;
const [statusUpdating, setStatusUpdating] = useState(null);

const handleStatusUpdate = async (status) => {
  if (selected.length === 0) {
    toast.error("No workers selected");
    return;
  }
  console.log("Selected Row IDs for status update:", selected); // ✅ debug log

  setStatusUpdating(status);

  const payload = {
 company_admin_ids: selected, // ✅ correct key expected by API
    status: status,
  };

  try {
    const res = await fetch(`${BASE_URL}/company-admins/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
     console.log("API Response:", result);
    if (!result.error) {
      toast.success(result.message || `Status updated to "${status}"`);

      const updated = tableData.map(row =>
        selected.includes(row.id) ? { ...row, status } : row
      );
      setTableData(updated);
      setSelected([]);
    } else {
      toast.error(result.message || "Failed to update status");
    }
  } catch (err) {
    console.error("Status update error:", err);
    toast.error("Something went wrong.");
  } finally {
    setStatusUpdating(null);
  }
};

const [activeTab, setActiveTab] = useState("workers"); // ✅ default tab is workers

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

  };



  const [apiData, setApiData] = useState(null);
const fetchCompanyData = async () => {
  try {
    setLoading(true);
    const res = await fetch(`${BASE_URL}/company-admins/${companyAdminId}/data`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const json = await res.json();
    console.log("Company Admin API:", json);

    if (!json.error) {
      setApiData(json.data); // ✅ Store the response inside apiData
    }
  } catch (error) {
    console.error("Error fetching company admin data:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchCompanyData();
}, [companyAdminId]);
  return (
    <Box sx={{ py: 2, px: 1 }}>

                <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 1, mb:1, border: '1px solid #E4E6EF' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
            sx={{
    "& .MuiTab-root": {
      fontSize: "1rem",          // smaller font size
      fontFamily: "Poppins, sans-serif",  // apply Poppins
      textTransform: "none",       // keeps normal case instead of uppercase
      minHeight: "40px",           // reduce tab height
      padding: "6px 12px",         // adjust padding if needed
    },
  }}
        >
            <Tab label={t("tabs.workers")} value="workers" />
  <Tab label={t("tabs.attendance")} value="attendance" />
  <Tab label={t("tabs.tasks")} value="tasks" />
  <Tab label={t("tabs.recentActivity")} value="recent_activity" />
  <Tab label={t("tabs.payments")} value="payments" />
  <Tab label={t("tabs.documents")} value="documents" />
  <Tab label={t("tabs.expenses")} value="expenses" />
        </Tabs>
      </Box>

{activeTab === "attendance" && (
  <AttendanceTable data={apiData?.data?.attendance} />
)}
{activeTab === "tasks" && (
  <TasksTable data={apiData?.data?.tasks} />
)}
{activeTab === "documents" && (
  <DocumentsTable data={apiData?.data?.documents} />
)}
{activeTab === "payments" && (
  <PaymentsTable data={apiData?.data?.payments} />
)}
{activeTab === "expenses" && (
  <ExpensesTable data={apiData?.data?.expenses} />
)}
{activeTab === "recent_activity" && (
  <RecentActivityTable data={apiData?.data?.attendance} />
)}
      {activeTab === "workers" && (
      <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', px: 2, mb: 2, rowGap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
              {t('activeDetailsTable.title')}
            </CustomText>
            {sortLoading && <CircularProgress size={20} sx={{ color: '#006EC2' }} />}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
           {selected.length > 0 ? (
  ['active', 'inactive', 'invited', 'requested'].map((status) => (
    <Button
      key={status}
      variant="contained"
      size="small"
      onClick={() => handleStatusUpdate(status)}
      sx={{
        px: 2,
        height: 34,
        fontSize: 13,
        fontWeight: 400,
        fontFamily: 'Poppins, sans-serif',
        borderRadius: '4px',
        textTransform: 'none',
        backgroundColor: status === 'active' ? '#4BCE97' : 
                         status === 'inactive' ? '#F87168' :
                         status === 'invited' ? '#579DFF' :
                         '#F5CD47',
                         color: status === 'active' ? '#164B35' : 
                         status === 'inactive' ? '#5D1F1A' :
                         status === 'invited' ? '#09326C' :
                         '#533F04',
      }}
    >
      {statusUpdating === status && (
        <CircularProgress size={16} thickness={4} sx={{  color: status === 'active' ? '#164B35' : 
                         status === 'inactive' ? '#5D1F1A' :
                         status === 'invited' ? '#09326C' :
                         '#533F04', mr: 1 }} />
      )}
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Button>
  ))
) : (
  // ...keep search + export here
     <>
       
            </>
)}
        
          </Box>
        </Box>



        {loading ? (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
    <CircularProgress />
  </Box>
) : tableData.length === 0 ? (
  <Box
    sx={{
      height: 300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
    }}
  >
    <img src={empty} alt="No Workers" style={{ width: 250, objectFit:"contain" }} />
       <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>
  </Box>
) : (
  <TableContainer component={Paper} sx={{ boxShadow: 'none',  }}>
    <Table size="small">
<TableHead sx={{
        whiteSpace: 'nowrap', // ✅ Prevent text wrap
     
        overflow: 'hidden',
    textOverflow: 'ellipsis',
}} >
  <TableRow sx={{ }} >
    {columns.map((col) =>
      col.key === 'action' ? null : ( // ⛔️ Skipping the action column
        <TableCell key={col.key} sx={{ ...HaederStyles, py: '6px', px: '6px',
          textAlign:"center"
             
         }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            {col.label}
            {col.sortable && (
              <IconButton onClick={() => handleSort(col.key)} size="small">
                {sortConfig.key === col.key && sortConfig.direction === 'asc' ? (
                  <NorthIcon sx={{ fontSize: 12 }} />
                ) : (
                  <SouthIcon sx={{ fontSize: 12 }} />
                )}
              </IconButton>
            )}
          </Box>
        </TableCell>
      )
    )}
  </TableRow>
</TableHead>
<TableBody>
  {tableData.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length} align="center">
          <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptyscreen} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>

        </Box>
      </TableCell>
    </TableRow>
  ) : (
    tableData.map((row, idx) => (
      <TableRow key={row.id} hover sx={{ cursor: 'pointer' }}>
        {columns.map((col) =>
          col.key === 'action' ? null : (
            <TableCell key={col.key} sx={{ ...DataStyles }}>
              {col.key === 'status' ? (
                <Box sx={{ pointerEvents: 'none' }}>
                  <StatusDropdown currentStatus={row.status} />
                </Box>
              ) : col.key === 'created_at' ? (
                (() => {
                  const createdAt = new Date(row[col.key]);
                  const formattedDate = createdAt.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  });
                  const formattedTime = createdAt.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  });
                  return `${formattedDate} - ${formattedTime.toLowerCase()}`;
                })()
              ) : (
                row[col.key] || '-'
              )}
            </TableCell>
          )
        )}
      </TableRow>
    ))
  )}
</TableBody>

    </Table>
  </TableContainer>
)}

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
    
                      <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
                      <Pagination
            count={totalPages}
            page={page + 1}
            onChange={(e, value) => setPage(value - 1)}
            shape="rounded"
            color="primary"
            size="small"
            sx={{
              '& .MuiPaginationItem-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: 13,
                fontWeight: 500,
              },
              '& .Mui-selected': {
                backgroundColor: '#E9F3FF',
                color: '#006EC2',
              },
            }}
          />
          </Box>
        </Box>
      </Box>
      )}
    </Box>
  );
};

export default ActiveDetailsTable;








